import { useEffect } from 'react'

const INN = '166014711920'
const EMAIL = 'hello@mybst.ru'
const SITE = 'mybst.ru'

export function TermsPage() {
  useEffect(() => {
    document.documentElement.classList.remove('dark')
    document.body.style.overflow = 'auto'
    document.body.style.height = 'auto'
    document.title = 'Публичная оферта — BST'
    return () => {
      document.body.style.overflow = ''
      document.body.style.height = ''
    }
  }, [])

  const section = (title: string, children: React.ReactNode) => (
    <section style={{ marginBottom: '32px' }}>
      <h2 style={{ fontSize: '16px', fontWeight: 700, color: '#1a1a1a', margin: '0 0 12px', borderBottom: '1px solid #e0e0e0', paddingBottom: '8px' }}>
        {title}
      </h2>
      <div style={{ fontSize: '14px', color: '#444', lineHeight: 1.8 }}>
        {children}
      </div>
    </section>
  )

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
      padding: '0',
    }}>
      {/* Header */}
      <header style={{
        background: '#fff',
        borderBottom: '1px solid #e0e0e0',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
          <div style={{
            width: '32px', height: '32px', borderRadius: '8px',
            background: '#5b6af0',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 900, color: '#fff', fontSize: '14px',
          }}>B</div>
          <span style={{ fontWeight: 900, fontSize: '20px', color: '#1a1a1a', letterSpacing: '-0.5px' }}>BST</span>
        </a>
        <span style={{ color: '#9b9b9b', fontSize: '13px', marginLeft: '4px' }}>/ Публичная оферта</span>
      </header>

      <main style={{ maxWidth: '780px', margin: '0 auto', padding: '40px 24px 60px' }}>
        <h1 style={{ fontSize: '26px', fontWeight: 900, color: '#1a1a1a', margin: '0 0 6px', letterSpacing: '-0.5px' }}>
          Публичная оферта на оказание услуг
        </h1>
        <p style={{ fontSize: '13px', color: '#9b9b9b', margin: '0 0 36px' }}>
          Редакция от 29 сентября 2026 г.
        </p>

        {section('1. Общие положения', <>
          <p>1.1. Настоящий документ является публичной офертой физического лица Иванова Олега Андреевича, осуществляющего деятельность в качестве самозанятого и применяющего специальный налоговый режим «Налог на профессиональный доход» в соответствии с Федеральным законом от 27.11.2018 № 422-ФЗ (далее — «Исполнитель»), и содержит все существенные условия договора об оказании услуг доступа к онлайн-конструктору сайтов и хостингу BST, расположенному по адресу: <strong>{SITE}</strong>.</p>
          <p>1.2. В соответствии со статьёй 437 Гражданского кодекса Российской Федерации, данный документ является публичной офертой, и в случае принятия изложенных условий физическое или юридическое лицо, производящее акцепт этой оферты (далее — «Пользователь»), обязуется соблюдать указанные условия.</p>
          <p>1.3. Акцептом настоящей оферты является совершение Пользователем действий по регистрации учётной записи в Сервисе или по оплате тарифного плана.</p>
        </>)}

        {section('2. Предмет договора', <>
          <p>2.1. Исполнитель оказывает Пользователю комплекс услуг, включающий:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li><strong>Доступ к конструктору сайтов (SaaS)</strong> — онлайн-инструмент для создания и редактирования сайтов с использованием готовых блоков и шаблонов без навыков программирования;</li>
            <li><strong>Хостинг опубликованных сайтов</strong> — размещение созданных Пользователем сайтов на серверах Исполнителя и обеспечение их доступности в сети Интернет;</li>
            <li><strong>Поддомен на {SITE}</strong> — предоставление адреса вида <strong>имя.{SITE}</strong> для опубликованного сайта с автоматически выпускаемым SSL-сертификатом;</li>
            <li><strong>Подключение собственного домена</strong> — возможность привязки доменного имени Пользователя к опубликованному сайту (доступно на платных тарифах).</li>
          </ul>
          <p>2.2. Состав и объём предоставляемых ресурсов хостинга (дисковое пространство, количество сайтов, возможность подключения собственного домена) определяется тарифным планом, выбранным Пользователем.</p>
          <p>2.3. Исполнитель не является регистратором доменных имён и не несёт ответственности за их приобретение, оплату и продление Пользователем.</p>
          <p>2.4. Услуги хостинга не предполагают предоставления Пользователю доступа к серверной инфраструктуре (SSH, FTP, административные панели). Управление сайтами осуществляется исключительно через интерфейс конструктора BST.</p>
        </>)}

        {section('3. Тарифы и оплата', <>
          <p>3.1. Сервис предоставляется на условиях бесплатного пробного периода длительностью 14 (четырнадцать) дней с момента регистрации. В пробный период Пользователю предоставляются функции конструктора и хостинг на поддомене <strong>имя.{SITE}</strong> в ограниченном объёме.</p>
          <p>3.2. По истечении пробного периода для продолжения использования хостинга и публикации сайтов требуется оформление платной подписки в соответствии с действующими тарифными планами.</p>
          <p>3.3. Актуальные тарифы и их стоимость опубликованы на странице сайта и могут изменяться Исполнителем. Изменение тарифов не затрагивает уже оплаченные периоды.</p>
          <p>3.4. Оплата производится банковской картой или иными доступными способами. Обязательства Пользователя по оплате считаются исполненными в момент фактического поступления средств.</p>
          <p>3.5. Все цены на сайте указаны в рублях Российской Федерации. НДС не облагается — Исполнитель применяет специальный налоговый режим «Налог на профессиональный доход».</p>
        </>)}

        {section('4. Права и обязанности сторон', <>
          <p><strong>4.1. Исполнитель обязуется:</strong></p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li>обеспечивать работоспособность конструктора сайтов не менее 99% времени в месяц;</li>
            <li>обеспечивать доступность опубликованных сайтов Пользователя не менее 99% времени в месяц (без учёта плановых технических работ, о которых Пользователь уведомляется заблаговременно);</li>
            <li>предоставлять бесплатный SSL-сертификат для поддоменов <strong>*.{SITE}</strong> и продлевать его автоматически;</li>
            <li>уведомлять Пользователя об изменениях условий оферты не менее чем за 7 дней;</li>
            <li>хранить данные Пользователя в соответствии с Политикой конфиденциальности.</li>
          </ul>
          <p><strong>4.2. Пользователь обязуется:</strong></p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li>не использовать хостинг и конструктор для создания и распространения контента, нарушающего законодательство Российской Федерации, в том числе материалов экстремистского характера, спама, фишинговых страниц;</li>
            <li>при размещении на создаваемых сайтах персональных данных третьих лиц (сотрудников, клиентов, авторов отзывов, посетителей и др.) — иметь надлежащее правовое основание для обработки таких данных, в частности согласия соответствующих субъектов на распространение (ст. 10.1 152-ФЗ) в необходимом объёме и целях;</li>
            <li>самостоятельно отвечать на запросы субъектов персональных данных, размещённых Пользователем на своём сайте, в том числе на требования об уточнении, блокировании и удалении их данных;</li>
            <li>не вводить в AI-запросы пароли, платёжные данные и персональные данные третьих лиц без наличия соответствующего правового основания;</li>
            <li>не предпринимать действий, нарушающих работу серверной инфраструктуры Исполнителя или третьих лиц (DDoS-атаки, эксплуатация уязвимостей и т.п.);</li>
            <li>не превышать ресурсные лимиты, предусмотренные выбранным тарифным планом;</li>
            <li>своевременно вносить оплату в соответствии с выбранным тарифом;</li>
            <li>хранить учётные данные в тайне и не передавать их третьим лицам;</li>
            <li>самостоятельно обеспечивать резервное копирование важного контента — Исполнитель не гарантирует полную сохранность данных при аппаратных сбоях.</li>
          </ul>
        </>)}

        {section('5. Ограничение ответственности', <>
          <p>5.1. Исполнитель не несёт ответственности за убытки Пользователя, возникшие вследствие ненадлежащего использования Сервиса или нарушения настоящей оферты.</p>
          <p>5.2. Исполнитель не несёт ответственности за содержимое сайтов, созданных и опубликованных Пользователями, включая размещённые на них персональные данные третьих лиц. Пользователь несёт полную юридическую ответственность за публикуемый контент, в том числе за наличие правовых оснований для обработки и распространения персональных данных иных лиц (ст. 10.1 152-ФЗ).</p>
          <p>5.3. Сервис предоставляется «как есть» (as is). Исполнитель не гарантирует, что Сервис будет соответствовать всем требованиям Пользователя.</p>
          <p>5.4. Исполнитель не несёт ответственности за временную недоступность опубликованных сайтов, вызванную:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li>плановыми техническими работами на серверной инфраструктуре;</li>
            <li>форс-мажорными обстоятельствами (стихийные бедствия, аварии сетей связи, действия государственных органов);</li>
            <li>действиями или бездействием операторов связи, дата-центров и иных третьих лиц;</li>
            <li>DDoS-атаками и иными вредоносными действиями в отношении инфраструктуры.</li>
          </ul>
          <p>5.5. Исполнитель не несёт ответственности за потерю данных вследствие аппаратных сбоев, действий третьих лиц или форс-мажорных обстоятельств. Пользователю рекомендуется самостоятельно хранить резервные копии важного контента.</p>
          <p>5.6. Совокупная ответственность Исполнителя перед Пользователем ограничена суммой фактически уплаченных Пользователем средств за последние 3 месяца.</p>
        </>)}

        {section('6. Прекращение хостинга и возврат средств', <>
          <p>6.1. Пользователь вправе отказаться от Сервиса в любой момент путём отмены подписки в личном кабинете. Доступ к конструктору и хостинг опубликованных сайтов сохраняются до конца оплаченного периода.</p>
          <p>6.2. По истечении оплаченного периода при отсутствии продления опубликованные сайты переводятся в неактивный статус (становятся недоступны по URL). Данные проекта сохраняются в личном кабинете в течение 30 (тридцати) дней, после чего могут быть удалены безвозвратно.</p>
          <p>6.3. Возврат денежных средств осуществляется по письменному запросу на <strong>{EMAIL}</strong> в течение 14 дней с момента оплаты при условии, что хостинг не использовался (сайты не публиковались и не были доступны в сети Интернет).</p>
          <p>6.4. Исполнитель вправе немедленно приостановить хостинг сайта без возврата оплаченных средств в случае:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li>размещения контента, нарушающего законодательство РФ или права третьих лиц;</li>
            <li>использования хостинга для рассылки спама, фишинга или DDoS-атак;</li>
            <li>превышения ресурсных лимитов тарифного плана, оказывающего негативное влияние на других пользователей.</li>
          </ul>
          <p>6.5. При получении официального предписания государственных органов РФ Исполнитель обязан приостановить хостинг соответствующего сайта незамедлительно.</p>
        </>)}

        {section('7. Интеллектуальная собственность', <>
          <p>7.1. Все права на Сервис, включая программный код, дизайн, шаблоны и блоки, принадлежат Исполнителю или его лицензиарам.</p>
          <p>7.2. Контент, созданный Пользователем с помощью Сервиса, является собственностью Пользователя. Пользователь предоставляет Исполнителю неисключительную лицензию на хранение, воспроизведение и отображение этого контента в рамках оказания услуг хостинга.</p>
          <p>7.3. Пользователь не вправе копировать, распространять или создавать производные произведения на основе платформы BST.</p>
        </>)}

        {section('8. Персональные данные', <>
          <p>8.1. Исполнитель обрабатывает персональные данные Пользователя в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и Политикой конфиденциальности, размещённой по адресу <strong>{SITE}/privacy</strong>.</p>
          <p>8.2. Регистрируясь в Сервисе, Пользователь даёт согласие на обработку своих персональных данных в объёме, необходимом для оказания услуг.</p>
        </>)}

        {section('9. Изменение условий оферты', <>
          <p>9.1. Исполнитель вправе в одностороннем порядке вносить изменения в настоящую оферту с уведомлением Пользователей по email не менее чем за 7 дней до вступления изменений в силу.</p>
          <p>9.2. Если Пользователь не согласен с изменёнными условиями, он вправе расторгнуть договор до момента вступления изменений в силу, направив запрос на {EMAIL}.</p>
        </>)}

        {section('10. Применимое право и разрешение споров', <>
          <p>10.1. Настоящая оферта регулируется законодательством Российской Федерации.</p>
          <p>10.2. Все споры рассматриваются в претензионном порядке. Срок ответа на претензию — 30 дней. При недостижении согласия споры рассматриваются в суде по месту жительства Исполнителя, за исключением случаев, когда Пользователем является физическое лицо, приобретающее услуги для личных, семейных и иных нужд, не связанных с осуществлением предпринимательской деятельности; в таком случае применяются правила о подсудности, установленные Законом РФ «О защите прав потребителей».</p>
        </>)}

        {section('11. Реквизиты исполнителя', <>
          <p>Иванов Олег Андреевич</p>
          <p>Статус: самозанятый (НПД, Закон № 422-ФЗ)</p>
          <p>ИНН: {INN}</p>
          <p>Email: <a href={`mailto:${EMAIL}`} style={{ color: '#5b6af0' }}>{EMAIL}</a></p>
          <p>Сайт: <a href={`https://${SITE}`} style={{ color: '#5b6af0' }}>{SITE}</a></p>
        </>)}
      </main>

      <footer style={{
        background: '#fff', borderTop: '1px solid #e0e0e0',
        padding: '20px 24px', textAlign: 'center',
        fontSize: '13px', color: '#9b9b9b',
        display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap',
      }}>
        <a href="/terms" style={{ color: '#9b9b9b', textDecoration: 'none' }}>Оферта</a>
        <a href="/privacy" style={{ color: '#9b9b9b', textDecoration: 'none' }}>Конфиденциальность</a>
        <a href="/cookies" style={{ color: '#9b9b9b', textDecoration: 'none' }}>Cookie</a>
        <span>© {new Date().getFullYear()} BST</span>
      </footer>
    </div>
  )
}
